import axiosInstance from './axiosInstance';
import config from '../config';

const BASE = `${config.API_BASE_URL}/PurchaseConsolidation`;

export interface BranchQuantityDto {
  branchId: number;
  branchName: string;
  branchNameAr: string;
  purchaseOrderId: number;
  poNumber: string;
  documentNumber: string;
  quantity: number;
  unitPrice: number;
  totalPrice: number;
}

export interface ConsolidatedItemDto {
  itemId: number;
  itemName: string;
  itemNameAr: string;
  itemCode: string;
  categoryId: number;
  categoryName: string;
  categoryNameAr: string;
  unitId: number;
  unitName: string;
  unitNameAr: string;
  totalQuantity: number;
  averageUnitPrice: number;
  totalAmount: number;
  branchDetails: BranchQuantityDto[];
}

export interface ConsolidationResultDto {
  fromDate: string;
  toDate: string;
  documentType: string;
  totalOrders: number;
  totalBranches: number;
  totalItems: number;
  grandTotal: number;
  supplierName?: string;
  custodyName?: string;
  items: ConsolidatedItemDto[];
}

export interface BranchPriceDetailDto {
  branchId: number;
  branchName: string;
  branchNameAr: string;
  currentUnitPrice: number;
  quantity: number;
  affectedLines: number;
}

export interface PricingSummaryItemDto {
  itemId: number;
  itemName: string;
  itemNameAr: string;
  itemCode: string;
  categoryId: number;
  categoryName: string;
  categoryNameAr: string;
  unitId: number;
  unitName: string;
  unitNameAr: string;
  currentUnitPrice: number;
  totalQuantity: number;
  affectedLines: number;
  branchPrices: BranchPriceDetailDto[];
}

export interface PricingSummaryResultDto {
  fromDate: string;
  toDate: string;
  documentType: string;
  totalDocuments: number;
  totalLines: number;
  supplierName?: string;
  custodyName?: string;
  items: PricingSummaryItemDto[];
}

export const consolidationService = {
  getConsolidation: async (params: {
    fromDate: string;
    toDate?: string;
    documentType?: string;
    branchIds?: number[];
    supplierId?: number;
    custodyId?: number;
    categoryId?: number;
    search?: string;
  }): Promise<ConsolidationResultDto> => {
    const q = new URLSearchParams({ fromDate: params.fromDate });
    if (params.toDate) q.append('toDate', params.toDate);
    if (params.documentType) q.append('documentType', params.documentType);
    if (params.branchIds?.length) q.append('branchIds', params.branchIds.join(','));
    if (params.supplierId) q.append('supplierId', params.supplierId.toString());
    if (params.custodyId) q.append('custodyId', params.custodyId.toString());
    if (params.categoryId) q.append('categoryId', params.categoryId.toString());
    if (params.search) q.append('search', params.search);
    const response = await axiosInstance.get<ConsolidationResultDto>(`${BASE}/consolidation?${q}`);
    return response.data;
  },

  getPricingSummary: async (params: {
    fromDate: string;
    toDate?: string;
    documentType?: string;
    branchIds?: number[];
    supplierId?: number;
    custodyId?: number;
    categoryId?: number;
    search?: string;
  }): Promise<PricingSummaryResultDto> => {
    const q = new URLSearchParams({ fromDate: params.fromDate });
    if (params.toDate) q.append('toDate', params.toDate);
    if (params.documentType) q.append('documentType', params.documentType);
    if (params.branchIds?.length) q.append('branchIds', params.branchIds.join(','));
    if (params.supplierId) q.append('supplierId', params.supplierId.toString());
    if (params.custodyId) q.append('custodyId', params.custodyId.toString());
    if (params.categoryId) q.append('categoryId', params.categoryId.toString());
    if (params.search) q.append('search', params.search);
    const response = await axiosInstance.get<PricingSummaryResultDto>(`${BASE}/pricing-summary?${q}`);
    return response.data;
  },
};
